import { Mapper } from "planning-portal-library/src/lib/core/base";
import { MasterPlanTypeWebEntity } from "./master-plan-type-web-entity";
import { MasterPlanType } from "planning-portal-library/src/lib/core/domain/models/master-plan-type";



export class MasterPlanTypesRepositoryMapper extends Mapper<
MasterPlanTypeWebEntity,
  MasterPlanType
> {
  constructor() {
    super();
  }

  mapFrom(param: MasterPlanTypeWebEntity): MasterPlanType {
    return {
        name: param.name,
      id: param.id
    };
  }

  mapTo(param: MasterPlanType): MasterPlanTypeWebEntity {
    return {
        name: param.name,
        id: param.id
      };
  }
}